import React from "react";
import Icon from "sulu-admin-bundle/components/Icon";

const TypeOfEventType = ({
  eventDetails,
  setEventDetails,
  changeCallback,
  confirmCallback,
  players
}) => {

    return (
        <div
            style={{
                padding: "10px 30px",
                display: "flex",
                alignItems: "center",
                width: "85%"
            }}
        >
            <div
                style={{
                    borderRadius: "50%",
                    backgroundColor: "transparent",
                    border: "1px solid black",
                    height: 35,
                    width: 35,
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: 20,
                }}
            >
                <Icon name="su-user" />
            </div>

            {eventDetails?.goalkeeperSelected && (
                <button
                    style={{
                        borderRadius: 5,
                        backgroundColor: eventDetails?.sideNotSelected?.teamColor,
                        border: "2px solid black",
                        fontWeight: "700",
                        fontSize: "16px",
                        height: "45px",
                        width: "41.7%",
                        marginRight: '30px',
                    }}
                >
                    <span>{eventDetails?.goalkeeperSelected?.playerName}</span>
                </button>
            )}

            {eventDetails?.goalkeeperSelected && (
                <button
                    style={{
                        border: "none",
                        backgroundColor: "transparent",
                        fontSize: "16px",
                    }}
                    onClick={() => {
                        setEventDetails((data) => ({
                            ...data,
                            goalkeeperSelected: null,
                            typeOfCornerGoalSelected: null,
                        }));
                        changeCallback && changeCallback();
                    }}
                >
                    X
                    <span
                        style={{
                            border: "none",
                            backgroundColor: "transparent",
                            fontSize: "16px",
                            textDecoration: "underline",
                            marginLeft: 5,
                        }}
                    >
                        Ändern
                    </span>
                </button>
            )}
            {!eventDetails?.goalkeeperSelected && (
                <div
                    style={{
                        display:" grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "10px",
                        width: "84.5%",
                        marginRight: "30px",
                    }}
                >
                    {players?.map((tg, index) => {
                        return (
                            <button
                                key={index}
                                style={{
                                    borderRadius: 5,
                                    backgroundColor: eventDetails?.sideNotSelected?.teamColor,
                                    border: "2px solid black",
                                    height: 45,
                                    fontWeight: "700",
                                    fontSize: "16px"
                                }}
                                onClick={() => {
                                    setEventDetails((data) => ({
                                        ...data,
                                        goalkeeperSelected: tg,
                                        typeOfEventTypeSelected: {id: 32, name:'Shoot'}
                                    }));
                                    confirmCallback && confirmCallback();
                                }}
                            >
                                {tg?.playerName}
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default TypeOfEventType;
